var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"page\"\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;